<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="add">新 增</el-button>
      <div>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.popoverName"
          placeholder="请输入名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.popoverCode"
          placeholder="请输入编码"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="popoverCode"
          label="文本编号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="popoverType"
          label="文本类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="popoverName"
          label="文本名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="popoverExtraContent"
          label="气泡文本外部内容"
          width="400"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="popoverIntraContent"
          label="气泡文本内部内容"
          width="400"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200px"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="edit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      :title="title"
      width="1200px"
    >
      <el-form
        v-if="dialogVisible"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item label="文本名称" prop="popoverName">
          <el-input
            style="width:300px"
            v-model.trim="ruleForm.popoverName"
            maxlength="20"
            size="small"
            clearable
            placeholder="请输入单行文本，限制40个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="文本编码" prop="popoverCode">
          <el-input
            style="width:300px"
            v-model.trim="ruleForm.popoverCode"
            maxlength="40"
            size="small"
            clearable
            placeholder="请输入单行文本，限制40个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="文本类型" prop="popoverType">
          <el-input
            style="width:300px"
            disabled
            v-model.trim="ruleForm.popoverType"
            maxlength="40"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="气泡文本外部内容" prop="popoverExtraContent">
          <hm-rich-editor
            v-model="ruleForm.popoverExtraContent"
            :html="ruleForm.popoverExtraContent"
          />
        </el-form-item>
        <el-form-item label="气泡文本内部内容" prop="popoverIntraContent">
          <hm-rich-editor
            v-model="ruleForm.popoverIntraContent"
            :html="ruleForm.popoverIntraContent"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="handleClose" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmRichEditor from "@/components/HmRichEditor";
export default {
  components: {
    HmRichEditor
  },
  data() {
    return {
      dialogVisible: false,
      title: "",
      searchCondition: {},
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      ruleForm: {
        popoverName: "",
        popoverCode: "",
        popoverType: "text",
        popoverExtraContent: "",
        popoverIntraContent: ""
      },
      rules: {
        popoverName: {
          required: true,
          trrger: "blur",
          message: "请输入文本名称"
        },
        popoverCode: {
          required: true,
          trrger: "blur",
          message: "请输入文本编码"
        },
        popoverType: {
          required: true,
          trrger: "blur",
          message: "请选择文本类型"
        },
        popoverExtraContent: {
          required: true,
          trrger: "blur",
          message: "请输入文本内容"
        },
        popoverIntraContent: {
          required: true,
          trrger: "blur",
          message: "请输入文本内容"
        }
      },

      row: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        if (this.title === "编辑") {
          params.id = this.row.id;
        }

        const { code } = await this.$store.dispatch(
          "addInterfacePopoverInfo",
          params
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.resetRuleForm();
          this.dialogVisible = false;

          this.queryList();
        }
      }
    },
    resetRuleForm() {
      // this.$nextTick(() => {});
      //
      setTimeout(() => {
        this.ruleForm.popoverName = "";
        this.ruleForm.popoverCode = "";
        this.ruleForm.popoverType = "text";
        this.ruleForm.popoverExtraContent = "";
        this.ruleForm.popoverIntraContent = "";
      }, 0);
      setTimeout(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
      }, 0);
    },
    handleClose() {
      this.resetRuleForm();
      this.dialogVisible = false;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    edit(row) {
      this.$router.push({
        name: "SetPopover",
        query: {
          type: "edit",
          row: JSON.stringify(row)
        }
      });
      // this.row = row;
      // this.title = "编辑";
      // this.dialogVisible = true;
      // for (let key in row) {
      //   if (this.ruleForm.hasOwnProperty(key)) {
      //     this.ruleForm[key] = row[key];
      //   }
      // }
    },
    add() {
      this.$router.push({
        name: "SetPopover"
      });
      // this.title = "新增";
      // this.dialogVisible = true;
      // this.resetRuleForm();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "interfacePopoverInfoList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
